import styled, { css } from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "elements__Container",
  componentId: "x1mgn-0"
})(["display:flex;flex-direction:row;align-items:center;width:", ";height:4rem;overflow:hidden;border-radius:", ";border:1px solid ", ";background-color:", ";", ";", ";", ";", ";", ";", ";", ";"], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var dimensions = _ref2.theme.dimensions;
  return dimensions.radius;
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.lightGrey;
}, function (_ref4) {
  var palette = _ref4.theme.palette;
  return palette.white;
}, function (_ref5) {
  var ghost = _ref5.ghost;
  return ghost && css(["border-color:transparent;"]);
}, function (_ref6) {
  var hasFocus = _ref6.hasFocus;
  return hasFocus && css(["border-color:", ";"], function (_ref7) {
    var palette = _ref7.theme.palette;
    return palette.primary["default"];
  });
}, function (_ref8) {
  var error = _ref8.error;
  return error && css(["border-color:", ";"], function (_ref9) {
    var palette = _ref9.theme.palette;
    return palette.failure["default"];
  });
}, function (_ref10) {
  var warning = _ref10.warning;
  return warning && css(["border-color:", ";"], function (_ref11) {
    var palette = _ref11.theme.palette;
    return palette.warning["default"];
  });
}, function (_ref12) {
  var success = _ref12.success;
  return success && css(["border-color:", ";"], function (_ref13) {
    var palette = _ref13.theme.palette;
    return palette.success["default"];
  });
}, function (_ref14) {
  var info = _ref14.info;
  return info && css(["border-color:", ";"], function (_ref15) {
    var palette = _ref15.theme.palette;
    return palette.primary["default"];
  });
}, function (_ref16) {
  var disabled = _ref16.disabled;
  return disabled && css(["opacity:0.4;border-color:", ";"], function (_ref17) {
    var palette = _ref17.theme.palette;
    return palette.lightGrey;
  });
});
export var InputElement = styled.input.withConfig({
  displayName: "elements__InputElement",
  componentId: "x1mgn-1"
})(["flex:1;height:100%;width:100%;background-color:", ";padding:0 ", ";border-radius:", ";&::placeholder{color:", ";font-size:", ";}font-size:", ";border:none;text-align:left;&:focus,&:active{outline:none;}"], function (_ref18) {
  var palette = _ref18.theme.palette;
  return palette.white;
}, function (_ref19) {
  var dimensions = _ref19.theme.dimensions;
  return dimensions.small;
}, function (_ref20) {
  var dimensions = _ref20.theme.dimensions;
  return dimensions.radius;
}, function (_ref21) {
  var palette = _ref21.theme.palette;
  return palette.darGrey;
}, function (_ref22) {
  var fonts = _ref22.theme.fonts;
  return fonts.size.medium;
}, function (_ref23) {
  var fonts = _ref23.theme.fonts;
  return fonts.size.big;
});